module.exports = __webpack_public_path__ + "img/journalist-1.95143be5.png";